import React, { useState, useEffect, useCallback } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import logo from "../../assets/images/logo.png"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import Dropzone from "react-dropzone"
import { URLS } from "../../Url"
import Select from "react-select"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormGroup,
} from "reactstrap"
import debounce from "lodash/debounce"

function AddAdvertisements() {
  const [form, setForm] = useState({
    name: "",
    advcategoryId: "",
    priorityId: "",
    fromDate: "",
    toDate: "",
    advtype: "",
    productId: "",
    type: "image",
    deltype: "",
  })

  const [selectedFiles, setSelectedFiles] = useState([])
  const [price, setPrice] = useState("")
  const history = useHistory()
  const [priority, setPriority] = useState([])
  const [cities, setCities] = useState([])
  const [selectedCityOptions, setSelectedCityOptions] = useState([])
  const [categories, setCategories] = useState([])
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [labels, setLabels] = useState("")

  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = GetAuth ? JSON.parse(GetAuth) : null
  const token = TokenJson?.token

  const handleCitySelect = selectedOptions => {
    setSelectedCityOptions(selectedOptions)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
    }))

    if (name === "priorityId" && value) {
      fetchCities(value)
      const selectedPriority = priority.find(p => p._id === value)
      if (selectedPriority) {
        setPrice(selectedPriority.price)
      }
    } else if (name === "priorityId" && !value) {
      setCities([])
      setSelectedCityOptions([])
      setLabels("")
    }
  }

  const fetchCities = useCallback(
    debounce(async Id => {
      if (!token) {
        toast.error("Authentication token not found")
        return
      }

      try {
        const response = await axios.post(
          URLS.AdvPriorityLocations,
          { advpriceId: Id },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setCities(response.data.data?.values || [])
        setLabels(response.data.data?.label || "")
      } catch (error) {
        console.error("Fetch cities error:", error)
        toast.error("Failed to fetch cities")
      }
    }, 300),
    [token]
  )

  const getCategories = useCallback(async () => {
    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    try {
      const response = await axios.post(
        URLS.GetAdvertisementCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setCategories(response.data.advcategorys || [])
    } catch (error) {
      console.error("Fetch categories error:", error)
      toast.error("Failed to fetch categories")
    }
  }, [token])

  const getProducts = useCallback(async () => {
    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    try {
      const response = await axios.post(
        URLS.GetProduct,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setProducts(response.data.products || [])
    } catch (error) {
      console.error("Fetch products error:", error)
      toast.error("Failed to fetch products")
    }
  }, [token])

  const handleCategoryChange = async e => {
    const { value } = e.target
    setForm(prev => ({
      ...prev,
      advcategoryId: value,
      priorityId: "",
    }))
    setPriority([])
    setCities([])
    setSelectedCityOptions([])
    setLabels("")
    setPrice("")

    if (value && token) {
      try {
        const response = await axios.post(
          URLS.GetAdvertisementByPriority,
          { advcategoryId: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setPriority(response.data.data || [])
      } catch (error) {
        console.error("Fetch priorities error:", error)
        toast.error("Failed to fetch priorities")
      }
    }
  }

  useEffect(() => {
    getCategories()
    getProducts()
  }, [getCategories, getProducts])

  const cityOptions =
    cities?.map(city => ({
      value: city.id,
      label: city.name,
    })) || []

  const authData = JSON.parse(localStorage.getItem("authUser") || "{}")
  const vendorDetails = authData?.vendor || {}

  const handleSubmit = async e => {
    e.preventDefault()

    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    if (selectedFiles.length === 0) {
      toast.error("Please upload a file")
      return
    }

    if (selectedCityOptions.length === 0) {
      toast.error("Please select at least one city")
      return
    }

    // Validate dates
    if (form.fromDate && form.toDate) {
      const fromDate = new Date(form.fromDate)
      const toDate = new Date(form.toDate)

      if (toDate < fromDate) {
        toast.error("End date cannot be before start date")
        return
      }
    }

    setIsLoading(true)

    try {
      const delieverIds = selectedCityOptions.map(option => option.value)

      const formData = new FormData()
      formData.append("name", form.name)
      formData.append("priorityId", form.priorityId)
      formData.append("advcategoryId", form.advcategoryId)
      formData.append("advtype", form.advtype)
      formData.append("fromDate", form.fromDate)
      formData.append("toDate", form.toDate)
      formData.append("productId", form.productId)
      formData.append("type", form.type)
      formData.append("deltype", labels)
      formData.append("delieverIds", JSON.stringify(delieverIds))

      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("image", selectedFiles[i].file || selectedFiles[i])
      }

      const response = await axios.post(URLS.AddAdvertisement, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      if (response.status === 200) {
        toast.success(response.data.message)
        handlePayment(response.data.advId)
      }
    } catch (error) {
      console.error("Submit error:", error)
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message)
      } else {
        toast.error("An error occurred while creating the advertisement")
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleAcceptedFiles = files => {
    if (files.length === 0) return

    const file = files[0]
    const fileType = file.type.split("/")[0]
    const allowedTypes = {
      image: ["image"],
      video: ["video"],
      reel: ["video"],
    }

    if (!allowedTypes[form.type]?.includes(fileType)) {
      toast.error(`Please select a ${form.type} file`)
      return
    }

    const maxSize = form.type === "image" ? 10 * 1024 * 1024 : 50 * 1024 * 1024
    if (file.size > maxSize) {
      toast.error(
        `File size too large. Max ${
          form.type === "image" ? "10MB" : "50MB"
        } allowed`
      )
      return
    }

    const cleanFile = new File([file], file.name, { type: file.type })

    let fileWithPreview = {
      file: cleanFile,
      name: file.name,
      type: file.type,
      size: file.size,
      formattedSize: formatBytes(file.size),
    }

    if (fileType === "image") {
      fileWithPreview.preview = URL.createObjectURL(file)
    }

    setSelectedFiles([fileWithPreview])
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const getAcceptedFileTypes = () => {
    switch (form.type) {
      case "image":
        return "image/*"
      case "video":
        return "video/*"
      case "reel":
        return "video/*"
      default:
        return "image/*"
    }
  }

  useEffect(() => {
    return () => {
      selectedFiles.forEach(file => {
        if (file.preview) {
          URL.revokeObjectURL(file.preview)
        }
      })
    }
  }, [selectedFiles])

  const handlePayment = data => {
    const totals = parseInt(price) * 100
    const options = {
      key: "rzp_test_HJG5Rtuy8Xh2NB",
      amount: totals,
      currency: "INR",
      name: "Bizzmate",
      description: "Bizzmate Transaction",
      image: logo,
      handler: async function (response) {
        try {
          const paymentResponse = await axios.post(
            URLS.AddAdvertisementPayment,
            {
              advId: data,
              paymentStatus: "completed",
              transactionId: response.razorpay_payment_id,
              amount: price,
              status: "active",
            },
            { headers: { Authorization: `Bearer ${token}` } }
          )

          if (paymentResponse.status === 200) {
            toast.success(paymentResponse.data.message)
            history.push("/Advertisements")
          }
        } catch (error) {
          console.error("Payment processing error:", error)
          toast.error("Failed to process payment")
        }
      },
      prefill: {
        name: `${vendorDetails.firstName || ""} ${
          vendorDetails.lastName || ""
        }`,
        email: vendorDetails.email || "",
        contact: vendorDetails.sellerMobile || "",
      },
      theme: {
        color: "#00578E",
      },
    }

    const rzp1 = new window.Razorpay(options)
    rzp1.open()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Create Advertisements"
          />
          <Form onSubmit={handleSubmit}>
            <Card>
              <CardBody>
                <Row>
                  <Col xl="12">
                    <Button
                      onClick={() => history.goBack()}
                      className="mb-1"
                      style={{ float: "right" }}
                      color="primary"
                      type="button"
                      size="sm"
                    >
                      <i className="far fa-arrow-alt-circle-left me-1"></i>
                      Back
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg="8">
                    <FormGroup>
                      <Label>Type </Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                        required
                      >
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                        <option value="reel">Reel</option>
                      </Input>
                    </FormGroup>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Name"
                        required
                        value={form.name}
                        name="name"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label>Advertisements Category Name</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.advcategoryId}
                        name="advcategoryId"
                        required
                        onChange={handleCategoryChange}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        {categories.map(data => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className="mb-3">
                      <Label>Priority</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.priorityId}
                        name="priorityId"
                        required
                        onChange={handleChange}
                        className="form-select"
                        disabled={!form.advcategoryId}
                      >
                        <option value="">Select</option>
                        {priority.map(data => (
                          <option key={data._id} value={data._id}>
                            Priority : {data.priority} , Customer Reach :{" "}
                            {data.CustomerReach} Price: {data.price}/-
                          </option>
                        ))}
                      </Input>
                    </div>
                    {/* Price Display Section */}
                    {price && (
                      <div className="mb-3">
                        <Label htmlFor="price-display">
                          Deal Price <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control bg-light"
                          id="price-display"
                          value={`₹ ${price}`}
                          readOnly
                          style={{ fontWeight: "bold", fontSize: "16px" }}
                        />
                        <small className="text-muted">
                          This is the amount you'll be charged for creating this
                          deal
                        </small>
                      </div>
                    )}
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="start-date-input">
                            Start Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="start-date-input"
                            placeholder="Enter Start Date"
                            required
                            value={form.fromDate}
                            name="fromDate"
                            onChange={handleChange}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="end-date-input">
                            End Date
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="end-date-input"
                            placeholder="Enter End Date"
                            required
                            value={form.toDate}
                            name="toDate"
                            onChange={handleChange}
                            min={
                              form.fromDate ||
                              new Date().toISOString().split("T")[0]
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-3">
                      <Label>Adv Type</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.advtype}
                        name="advtype"
                        required
                        onChange={handleChange}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="store">Store</option>
                        <option value="product">Product</option>
                      </Input>
                    </div>
                    {form.advtype === "product" && (
                      <div className="mb-3">
                        <Label>Products</Label>
                        <span className="text-danger">*</span>
                        <Input
                          type="select"
                          value={form.productId}
                          name="productId"
                          required={form.advtype === "product"}
                          onChange={handleChange}
                          className="form-select"
                        >
                          <option value="">Select</option>
                          {products.map(data => (
                            <option key={data._id} value={data._id}>
                              {data.name}
                            </option>
                          ))}
                        </Input>
                      </div>
                    )}
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="city-select">
                          {labels || "locations"}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="city-select"
                          placeholder="Select locations"
                          value={selectedCityOptions}
                          options={cityOptions}
                          isSearchable={true}
                          onChange={handleCitySelect}
                          isMulti
                          aria-label="Select locations"
                          isDisabled={
                            !form.priorityId || cityOptions.length === 0
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col lg="4" className="mb-4">
                    <div className="m-2">
                      <h5 style={{ fontWeight: "bold" }}>{form.type} Upload</h5>
                      <div className="w-100">
                        <Dropzone
                          onDrop={acceptedFiles => {
                            handleAcceptedFiles(acceptedFiles)
                          }}
                          accept={getAcceptedFileTypes()}
                          multiple={false}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick mt-2"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>
                                  Drop {form.type} file here or click to upload
                                </h4>
                                <p className="text-muted">
                                  {form.type === "image"
                                    ? "Supports JPG, PNG (Max 10MB)"
                                    : "Supports MP4, MOV (Max 50MB)"}
                                </p>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {selectedFiles.map((f, i) => (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  {f.preview ? (
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="40"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                  ) : (
                                    <Col className="col-auto">
                                      <i
                                        className="bx bxs-video text-primary"
                                        style={{ fontSize: "2rem" }}
                                      />
                                    </Col>
                                  )}
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                      {f.name}
                                    </Link>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                    <p className="mb-0">
                                      <small>Type: {form.type}</small>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-2" style={{ float: "right" }}>
                      <Button
                        type="submit"
                        style={{ width: "120px" }}
                        color="primary"
                        className="m-1 btn-sm"
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}{" "}
                        <i className="fas fa-check-circle"></i>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddAdvertisements
